<template>
  <!-- Меню правого клика по сообщению (p4a): тёмная плашка в точке клика -->
  <div
    v-if="target"
    ref="menu"
    class="message-menu"
    :style="position"
    role="menu"
  >
    <button
      type="button"
      class="message-menu__item"
      role="menuitem"
      @click="choose('reply')"
    >
      <v-icon size="20">
        mdi-reply
      </v-icon>
      Ответить
    </button>
    <button
      v-if="target.message.text"
      type="button"
      class="message-menu__item"
      role="menuitem"
      @click="choose('copy')"
    >
      <v-icon size="20">
        mdi-content-copy
      </v-icon>
      Скопировать
    </button>
    <button
      v-if="target.attachment"
      type="button"
      class="message-menu__item"
      role="menuitem"
      @click="choose('save')"
    >
      <v-icon size="20">
        mdi-download
      </v-icon>
      Сохранить изображение
    </button>
  </div>
</template>

<script>
  // Меню 240 × до 3 пунктов по 40: не даём ему уйти за правый и нижний край окна.
  const MENU_WIDTH = 240
  const MENU_HEIGHT = 136

  export default {
    name: 'MessageMenu',
    props: {
      // { message, attachment, event } - что кликнули и где; null - меню закрыто.
      target: { type: Object, default: null },
    },
    computed: {
      position () {
        if (!this.target) return {}
        const { clientX, clientY } = this.target.event

        return {
          left: `${Math.min(clientX, window.innerWidth - MENU_WIDTH - 8)}px`,
          top: `${Math.min(clientY, window.innerHeight - MENU_HEIGHT - 8)}px`,
        }
      },
    },
    watch: {
      target (value) {
        if (value) this.attach()
        else this.detach()
      },
    },
    beforeDestroy () {
      this.detach()
    },
    methods: {
      choose (action) {
        this.$emit('action', { action, ...this.target })
        this.$emit('close')
      },
      attach () {
        // Слушатели после текущего клика, иначе тот же клик сразу закроет меню.
        setTimeout(() => {
          document.addEventListener('mousedown', this.onOutside)
          document.addEventListener('keydown', this.onKey)
          window.addEventListener('scroll', this.close, true)
        })
      },
      detach () {
        document.removeEventListener('mousedown', this.onOutside)
        document.removeEventListener('keydown', this.onKey)
        window.removeEventListener('scroll', this.close, true)
      },
      onOutside (event) {
        if (this.$refs.menu && !this.$refs.menu.contains(event.target)) this.close()
      },
      onKey (event) {
        if (event.key === 'Escape') this.close()
      },
      close () {
        this.$emit('close')
      },
    },
  }
</script>

<style scoped lang="less">
@import '../tokens.less';

.message-menu {
  position: fixed;
  z-index: 300;
  width: 240px;
  padding: 6px 0;
  border-radius: 10px;
  background: @fakt-dark;
  box-shadow: 0 8px 24px rgba(0, 0, 0, .24);
}

.message-menu__item {
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 16px;
  font-size: 14px;
  color: @fakt-white;

  .v-icon {
    color: @fakt-white !important;
  }

  &:hover {
    background: rgba(255, 255, 255, .12);
  }
}
</style>
